import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { ShopOffersItem } from '@app/shared/models/shop-offers.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BoxComponent } from '@app/shared/components/liveops/box/box.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-progressbag-info-2-modal',
  templateUrl: './progressbag-info-2.component.html',
  styleUrls: ['./progressbag-info-2.component.scss'],
  standalone: true,
  imports: [BoxComponent, ButtonComponent, NavigationButtonComponent, SharedModule],
})
export class ProgressbagInfo2ModalComponent implements OnInit {
  componentDestroy: () => Observable<unknown>;

  protected readonly progressbagInfoModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  public logger = inject(LoggerService);
  private translateService = inject(TranslateService);

  lang = signal<string>('');
  progressbag = signal<LimitedTimeEvent | null>(null);
  progressbagShopItem = signal<ShopOffersItem | null>(null);
  progressbagMinPurchase = signal<string | null>(null);
  progressbagCurrencySymbol = signal<string | null>(null);

  ngOnInit(): void {
    this.progressbag.set(this.progressbagInfoModalData.data);
    this.lang.set(this.translateService.currentLang);
  }

  openInfo1(): void {
    this.closeModal();

    this.eventManager.openModal(
      new Modal(NonPersistedModalName.ProgressbagInfoModalComponent, ModalType.View, this.progressbag())
    );
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.progressbagInfoModalData.id, ModalType.View, this.progressbagInfoModalData)
    );
  }

  closeViewModal(): void {
    const pb = this.progressbag();
    if (!pb) return;

    this.eventManager.closeModal(new Modal(pb.eventId, ModalType.View, pb));
  }
}
